import React from 'react';
import Div from '../Element/Div/Div';
import styles from './Backdrop.module.scss';

type BackdropProps = {
  /** Is backdrop visible */
  isVisible?: boolean;
  /** onCloseClick callback function */
  onCloseClick?: () => void;
};

const Backdrop: React.FunctionComponent<BackdropProps> = ({
  isVisible,
  onCloseClick,
}) => {
  return (
    <Div
      data-testid="backdrop"
      onClick={onCloseClick}
      className={[styles.backdrop, { [styles.backdrop__visible]: isVisible }]}
    />
  );
};

export default Backdrop;
